import { useEffect, useState } from 'react';
import { apiGet } from '../api/client';
import type { User } from '../api/types';

export interface Session {
  user: User | null;
  loading: boolean;
  error: string | null;
}

export function useSession(): Session {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const data = (await apiGet('/api/auth/me')) as { user?: User } | null;
        if (!cancelled) {
          setUser(data?.user ?? null);
        }
      } catch (e) {
        if (!cancelled) {
          setUser(null);
          setError(e instanceof Error ? e.message : 'Auth check failed');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return { user, loading, error };
}
